/**
 * Shared constants for LinCal storage and data
 */

/**
 * System project ID for holidays
 */
export const HOLIDAYS_PROJECT_ID = 'project-holidays';

/**
 * LocalStorage key for calendar data
 */
export const STORAGE_KEY = 'lincal_data';

/**
 * LocalStorage key for last seen version tracking
 */
export const VERSION_KEY = 'lincal_lastSeenVersion';

/**
 * Current data structure version
 */
export const CURRENT_VERSION = 1;
